import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IGatewayLanguageResponse } from '../../entity/interface/iGatewayLanguage';
import { IGatewayConfigurationResponse } from '../../entity/interface/iGatewayConfiguration';
import { IGatewayScreenResponse } from '../../entity/interface/iGatewayScreen';
import { IGetGatewayConfigurationUseCase } from '../../core/usecases/gateway/GetGatewayConfigurationUseCase';
import { IGetGatewayLanguageUseCase } from '../../core/usecases/gateway/GetGatewayLanguageUseCase';
import { IGetGatewayScreenUseCase } from '../../core/usecases/gateway/GetGatewayScreenUseCase';
import { JsonType } from '@intigral/types';
import { ScreenData } from '../../core/entities/ScreenEntities';

export interface IGatewayService {
    getGatewayConfiguration(
        endpoint: string,
        params: string,
        appKey: string
    ): Promise<IGatewayConfigurationResponse['data']>;
    getGatewayLanguage(appKey: string, language: string): Promise<JsonType>;
    getGatewayScreen(appKey: string, layout: string, screen: string, params: string): Promise<ScreenData>;
}

export class GatewayService implements IGatewayService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get getGatewayConfigurationUseCase(): IGetGatewayConfigurationUseCase {
        return container.resolve<IGetGatewayConfigurationUseCase>(DI.USECASES.IGetGatewayConfigurationUseCase);
    }

    private get getGatewayLanguageUseCase(): IGetGatewayLanguageUseCase {
        return container.resolve<IGetGatewayLanguageUseCase>(DI.USECASES.IGetGatewayLanguageUseCase);
    }

    private get getGatewayScreenUseCase(): IGetGatewayScreenUseCase {
        return container.resolve<IGetGatewayScreenUseCase>(DI.USECASES.IGetGatewayScreenUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getGatewayConfiguration(
        endpoint: string,
        params: string,
        appKey: string
    ): Promise<IGatewayConfigurationResponse['data']> {
        return await this.getGatewayConfigurationUseCase.execute(endpoint, appKey, params);
    }
    async getGatewayLanguage(appKey: string, language: string): Promise<JsonType> {
        return await this.getGatewayLanguageUseCase.execute(appKey, language);
    }
    async getGatewayScreen(appKey: string, layout: string, screen: string, params: string): Promise<ScreenData> {
        return await this.getGatewayScreenUseCase.execute(appKey, layout, screen, params);
    }
}
